import moment from 'moment';

export const CustomDateUtils = () => {
    return {
        formatDateToYYYYMMDD_HHMMSSFromUnixTime,
        formatDateToYYYYMMDD_HHmmss
    }
}

function formatDateToYYYYMMDD_HHMMSSFromUnixTime(iDate) {
    const date = new Date(Number(iDate));
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
}

function formatDateToYYYYMMDD_HHmmss(iDate) {
    return moment(iDate).format('YYYY-MM-DD HH:mm:ss');
}